/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Save_LedeInputs */

const en_us2_auth_save_lede = /** @type {(inputs: Auth_Save_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your answers are kept on this device. Sign in with your email to build your plan and keep everything. We'll send a 6-digit code, no password.`)
};

const pt_br2_auth_save_lede = /** @type {(inputs: Auth_Save_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suas respostas estão guardadas neste aparelho. Entre com seu e-mail para montar o programa e não perder nada. Mandamos um código de 6 dígitos, sem senha.`)
};

const es_419_auth_save_lede = /** @type {(inputs: Auth_Save_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus respuestas están guardadas en este dispositivo. Entra con tu email para armar tu plan y no perder nada. Te enviamos un código de 6 dígitos, sin contraseña.`)
};

const pt_pt2_auth_save_lede = /** @type {(inputs: Auth_Save_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As tuas respostas estão guardadas neste dispositivo. Entra com o teu e-mail para criar o plano e não perder nada. Enviamos um código de 6 dígitos, sem palavra-passe.`)
};

const fr_fr2_auth_save_lede = /** @type {(inputs: Auth_Save_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes réponses sont gardées sur cet appareil. Connecte-toi avec ton e-mail pour créer ton programme et tout conserver. On t'envoie un code à 6 chiffres, sans mot de passe.`)
};

const de_de2_auth_save_lede = /** @type {(inputs: Auth_Save_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Antworten sind auf diesem Gerät gespeichert. Melde dich mit deiner E-Mail an, um deinen Plan zu erstellen und nichts zu verlieren. Wir schicken einen 6-stelligen Code, kein Passwort.`)
};

const it_it2_auth_save_lede = /** @type {(inputs: Auth_Save_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le tue risposte sono salvate su questo dispositivo. Accedi con la tua email per creare la scheda senza perdere nulla. Ti mandiamo un codice di 6 cifre, niente password.`)
};

/**
* | output |
* | --- |
* | "Your answers are kept on this device. Sign in with your email to build your plan and keep everything. We'll send a 6-digit code, no password." |
*
* @param {Auth_Save_LedeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_save_lede = /** @type {((inputs?: Auth_Save_LedeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Save_LedeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_save_lede(inputs)
	if (locale === "es-419") return es_419_auth_save_lede(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_save_lede(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_save_lede(inputs)
	if (locale === "de-DE") return de_de2_auth_save_lede(inputs)
	if (locale === "it-IT") return it_it2_auth_save_lede(inputs)
	return en_us2_auth_save_lede(inputs)
});
export { auth_save_lede as "auth.save_lede" }